import { apiPost } from "./client";

export type ReviewDebugLineSubRequest = {
  idToken: string;
  tenantSlug: string;
};

export type ReviewDebugLineSubResponse = {
  lineSub: string;
  platformUserId: string;
  tenantSlug: string;
  roles: string[];
};

function parseReviewDebugLineSubResponse(value: unknown): ReviewDebugLineSubResponse {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    throw new Error("Invalid review debug response");
  }

  const record = value as Record<string, unknown>;

  if (
    typeof record.lineSub !== "string" ||
    typeof record.platformUserId !== "string" ||
    typeof record.tenantSlug !== "string" ||
    !Array.isArray(record.roles) ||
    !record.roles.every((role) => typeof role === "string")
  ) {
    throw new Error("Invalid review debug response");
  }

  return {
    lineSub: record.lineSub,
    platformUserId: record.platformUserId,
    tenantSlug: record.tenantSlug,
    roles: record.roles
  };
}

export async function postReviewDebugLineSub(
  request: ReviewDebugLineSubRequest
): Promise<ReviewDebugLineSubResponse> {
  const response = await apiPost<ReviewDebugLineSubRequest, unknown>(
    "/api/v1/review/debug/line-sub",
    request
  );
  return parseReviewDebugLineSubResponse(response);
}
